import { getTicket, getTickets } from './state';

export const getParticipantTypeName = () => getTicket()?.ParticipantTypeName;
export const getTicketTypeName = () => getTicket()?.TicketTypeName;
export const getHCPStatus = () => getTicket()?.EnableHCP;
export const getTicketsTypeName = (sep) => getTickets().map((el) => el?.TicketTypeName).join(sep);
